import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import styled from 'styled-components'
import Header from 'components/Header'
import Sidebar from 'components/Sidebar'
import Spinner from 'components/Spinner'
import SalesForceChat from 'components/SalesForceChat'
import Notifications from 'containers/Notifications'
import Opportunities from 'containers/Opportunities'
import mediaQuery from 'utils/mediaQuery'
import { getCookie, deleteCookie, clearAllListCache, firstName, lastName } from 'utils/helpers'
import routes from 'config/routes'
import * as Screens from 'screens'
import { login, isAuthenticated, isProcessing } from 'store/ducks/auth'
import UserDetails from 'containers/UserDetails'
import { clearResponseCache } from 'react-request'
import { Helmet } from "react-helmet"
import Wootric from 'components/Wootric'

// Componentes
import CursosPorTipoScreen from 'screens/CursosPorTipoScreen'
import AssinaturasScreen from 'screens/AssinaturasScreen'
import CursosScreen from 'screens/CursosScreen'

class Dashboard extends Component {

    state = {
        isSidebarOpen: false
    }

    componentWillMount() {
        if (!this.props.isAuthenticated) {
            this.props.requestLogin(this.props.location.pathname)
        }
    }

    componentDidUpdate(prevProps) {
        const prevPathname = prevProps.location.pathname
        const currentPathname = this.props.location.pathname
        const { isSidebarOpen } = this.state

        if (isSidebarOpen && prevPathname !== currentPathname) {
            this.setState({ isSidebarOpen: false })
        }
    }

    render() {

        if (this.props.isProcessing) {
            if (getCookie('loggedUser').length > 0) {
                deleteCookie('loggedUser');
                //Limpa o cache para personificação
                clearResponseCache()
                clearAllListCache()
            }
            return <Spinner text='Autenticando...' />
        }

        // Verifica  se não está logado e a rota é login
        if (!this.props.isAuthenticated && this.props.location.pathname === routes.login) {
            return <Route path={routes.login} component={Screens.Login} />
        }

        // Se logado e estiver na página de login
        if (this.props.isAuthenticated && this.props.location.pathname === routes.login) {
            return <Redirect to={routes.cursos} />
        }

        // Se não estiver logado, mostra mensagem que deve estar logado
        if (!this.props.isAuthenticated) {
            return <h1 style={{ textAlign: 'center' }}>Você precisa estar logado!</h1>
        }

        if (this.props.isAuthenticated) {
            return (
                <div>
                    <UserDetails>
                        {details => (
                            <div>
                                
                                <Helmet>
                                    <script>
                                        {`
                                            var beamer_config = {
                                            'product_id': 'QUXJzwyL29024',
                                            'user_firstname': '${firstName(details.name)}',
                                            'user_lastname': '${lastName(details.name)}',
                                            'user_email': '${details.email}',
                                            'user_id': ${details.id},
                                            'user_created_at': '${details.dataCriacao}'
                                            }
                                        `}
                                    </script>
                                </Helmet>

                                <SalesForceChat>
                                    {salesForce => (
                                        <div>
                                            <Header salesForce={salesForce} onMenuButtonClick={() => { this.setState({ isSidebarOpen: !this.state.isSidebarOpen }) }} />
                                            <Sidebar salesForce={salesForce} isSidebarOpen={this.state.isSidebarOpen} />
                                        </div>
                                    )}
                                </SalesForceChat>

                                <Content>

                                    {/* Notificações */}
                                    <Notifications scrollToTop />

                                    {/* Oportunidades */}
                                    <Opportunities />

                                    {/* Menus */}
                                    <Switch>

                                        {/* Rota Cursos */}
                                        <Route exact path={routes.cursos} component={() =>
                                            <React.Fragment>
                                                <CursosScreen />
                                                <Wootric title="Encontrar os cursos de seu interesse" email={details.email} id={details.id} user_created_at={details.dataCriacao} item='Cursos'/>
                                            </React.Fragment>
                                        } />

                                        {/* Rora Curso */}
                                        <Route exact path={routes.curso} component={Screens.CursoScreen} />

                                        {/* Rota Vídeo */}
                                        <Route exact path={routes.video} component={Screens.CursoScreen} />

                                        {/* Rota Aula */}
                                        <Route exact path={routes.aula} component={Screens.CursoScreen} />
                                        
                                        {/* Rota Fórum */}
                                        <Route exact path={routes.forum} component={Screens.ForumScreen} />

                                        {/* Rota Promoção TJ SP */}
                                        {(details.blackfriday && details.blackfriday.controller !== 'RenovarPromocaoFevereiro') && (
                                            <Route exact path={routes.promocaoJaneiro2026} component={Screens.PromocaoJaneiro2026Screen} />
                                        )}

                                        {/* Rota Promoção Janeiro 2026 */}
                                        {(details.blackfriday && details.blackfriday.controller === 'RenovarPromocaoFevereiro') && (
                                            <Route exact path={routes.renovacao} component={Screens.RenovacaoAntecipada2026Screen} />
                                        )}

                                        {/* Rota Assinaturas */}
                                        <Route exact path={routes.assinaturas} component={() =>
                                            <React.Fragment>
                                                <AssinaturasScreen />
                                                <Wootric title="Se matricular em novos produtos" email={details.email} id={details.id} user_created_at={details.dataCriacao} item='Catálogo de cursos'/>
                                            </React.Fragment>
                                        } />

                                        {/* Rota Monitorias */}
                                        <Route exact path={routes.monitorias} component={() =>
                                            <React.Fragment>
                                                <CursosPorTipoScreen titulo={'Monitorias'} tipo={'MONITORIA'} agenda={true} />
                                                <Wootric title="Participar de uma monitoria de seu interesse" email={details.email} id={details.id} user_created_at={details.dataCriacao} item='Monitorias' />
                                            </React.Fragment>
                                        } />

                                        {/* Rota Trilhas */}
                                        <Route exact path={routes.trilhas} component={() =>
                                            <React.Fragment>
                                                <CursosPorTipoScreen titulo={'Trilhas Estratégicas'} tipo={'trilha_estrategica'} agenda={false} />
                                                <Wootric title="Encontrar a trilha de seu interesse" email={details.email} id={details.id} user_created_at={details.dataCriacao} item='Trilhas Estratégicas' />
                                            </React.Fragment>
                                        } />

                                        {/* Rota Comunidades */}
                                        <Route exact path={routes.comunidades} component={Screens.ComunidadesScreen} />

                                        {/* Rota Comunidades ECJ */}
                                        <Route exact path={routes.comunidadesEcj} component={Screens.ComunidadesEcjScreen} />

                                        {/* Rota Simulados */}
                                        <Route exact path={routes.simulados} component={() =>
                                            <React.Fragment>
                                                <CursosPorTipoScreen titulo={'Simulados'} tipo={'SIMULADO'} agenda={true} />
                                                <Wootric title="Encontrar um simulado de seu interesse" email={details.email} id={details.id} user_created_at={details.dataCriacao} item='Simulados' />
                                            </React.Fragment>
                                        } />

                                        {/* Rota Cursos Exclusivos */}
                                        <Route exact path={routes.cursosExclusivos} component={() => <CursosPorTipoScreen titulo={'Cursos Exclusivos'} tipo={'EXCLUSIVO'} agenda={true} />} />

                                        {/* Rota Meus dados */}
                                        <Route path={routes.meusDados} component={Screens.MeusDadosScreen} />

                                        {/* Rota Meus Downloads */}
                                        <Route path={routes.meusDownloads} component={Screens.DownloadsScreen} />

                                        {/* Rota Métodos de Pagamento */}
                                        <Route path={routes.metodosDePagamento} component={Screens.MetodosDePagamentoScreen} />

                                        {/* Rota Agenda */}
                                        <Route path={routes.agenda} component={Screens.AgendaScreen} />

                                        {/* Rota Histórico de Compras */}
                                        <Route path={routes.historicoDeCompras} component={Screens.HistoricoScreen} />

                                        {/* Rota Certificados */}
                                        <Route path={routes.certificados} component={Screens.CertificadosScreen} />

                                        {/* Rota Ingressos */}
                                        <Route path={routes.ingressos} component={Screens.IngressosScreen} />

                                        {/* Rota Meus Chamados */}
                                        <Route path={routes.meusChamados} component={Screens.MeusChamadosScreen} />

                                        {/* Rota Mensagens */}
                                        <Route path={routes.mensagens} component={Screens.MensagensScreen} />

                                        {/* Rota Indicar Amigo */}
                                        <Route path={routes.indicarAmigo} component={Screens.IndicarAmigoScreen} />

                                        {/* Rota Suporte */}
                                        <Route path={routes.suporte} component={Screens.SuporteScreen} />

                                        {/* Rota Alertas */}
                                        <Route path={routes.alertas} component={Screens.AlertasScreen} />

                                        {/* Rota Sala VIP */}
                                        <Route path={routes.salaVip} component={Screens.SalaVipScreen} />

                                        {/* Rota Estude em Grupo */}
                                        <Route path={routes.estudeEmGrupo} component={() =>
                                            <React.Fragment>
                                                <CursosPorTipoScreen titulo={'Sala Vip'} tipo={'sala_vip'} agenda={true} />
                                                <Wootric title="Participar de um evento da Sala VIP" email={details.email} id={details.id} user_created_at={details.dataCriacao} item='Sala VIP' />
                                            </React.Fragment>
                                        } />

                                        {/* Rota Logout */}
                                        <Route path={routes.logout} component={Screens.LogoutScreen} />

                                        {/* Rota Coaching */}
                                        <Route path={routes.coaching} component={Screens.CoachingScreen} />

                                        {/* Rota Estratégia Cast */}
                                        <Route path={routes.estrategiaCast} component={Screens.EstrategiaCastScreen} />

                                        {/* Rota Indique um Amigo */}
                                        <Route path={routes.indiqueAmigo} component={Screens.IndiqueAmigoScreen} />

                                        {/* Rota Cursos Exclusivos ECJ */}
                                        <Route path={routes.cursosExclusivosECJ} component={() => <CursosPorTipoScreen titulo={'Cursos Exclusivos ECJ'} tipo={'ecj_exclusivo'}
                                        agenda={true} />} />

                                        {/* Rota Cursos de Extenção */}
                                        <Route path={routes.cursosExtensao} component={() => <CursosPorTipoScreen titulo={'Cursos de Extensão'} tipo={'ecj_extensao'} agenda={true} />} />

                                        {/* Rota Estudo Estratégico */}
                                        <Route path={routes.estudoEstrategico} component={() => <CursosPorTipoScreen titulo={'Estudo Estratégico'} tipo={'ecj_estrategico'} agenda={false} />} />

                                        {/* Rota Cursos Orais */}
                                        <Route path={routes.cursosOrais} component={() => <CursosPorTipoScreen titulo={'Cursos Orais'} tipo={'ecj_orais'} agenda={false} />} />

                                        {/* Rota Trilhas ECJ */}
                                        <Route exact path={routes.trilhasEcj} component={() => <CursosPorTipoScreen titulo={'Trilhas Estratégicas'} tipo={'ECJ_TRILHA_ESTRATEGICA'} agenda={false} />} />

                                        {/* Rota Simulados ECJ */}
                                        <Route path={routes.simuladosECJ} component={() => <CursosPorTipoScreen titulo={'Simulados (ECJ)'} tipo={'ecj_simulado'} agenda={true} />} />

                                        {/* Rota Rodadas */}
                                        <Route path={routes.rodadas} component={() => <CursosPorTipoScreen titulo={'Rodadas'} tipo={'ecj_rodadas'} agenda={false} />} />
                                        
                                        {/* Rota Reta Final */}
                                        <Route path={routes.retaFinalEcj} component={() => <CursosPorTipoScreen titulo={'Reta Final'} tipo={'ecj_reta_final'} agenda={false} />} />

                                        {/* Rota Informativos Estratégicos */}
                                        <Route path={routes.informativosEstrategicos} component={() => <CursosPorTipoScreen titulo={'Informativos estratégicos'} tipo={'ecj_info'} agenda={false} />} />

                                        {/* Rota vade Mecum */}
                                        <Route path={routes.vadeMecum} component={() => <CursosPorTipoScreen titulo={'Vade-Mécum Estratégico'} tipo={'ecj_vmecum'} agenda={false} />} />

                                        {/* Rotas OAB **********************************************/}

                                        {/* Rota Temas Especiais */}
                                        <Route path={routes.temasEspeciaisOab} component={() => <CursosPorTipoScreen titulo={'Temas Especiais'} tipo={'OAB_TEMAS_ESPECIAIS'}
                                        agenda={true} />} />

                                        {/* Rota Livrão */}
                                        <Route path={routes.livraoOab} component={() => <CursosPorTipoScreen titulo={'Livrão'} tipo={'OAB_LIVRAO'} agenda={false} />}
                                        />

                                        {/* Rota Simulados */}
                                        <Route path={routes.simuladosOab} component={() => <CursosPorTipoScreen titulo={'Simulados'} tipo={'OAB_SIMULADOS'} agenda={true} />} />

                                        {/* Rota reta Final */}
                                        <Route path={routes.retaFinalOab} component={() => <CursosPorTipoScreen titulo={'Reta Final'} tipo={'OAB_RETA_FINAL'} agenda={true} />} />

                                        {/* Rota Monitorias OAB */}
                                        <Route path={routes.monitoriasOab} component={() => <CursosPorTipoScreen titulo={'Monitorias'} tipo={'OAB_MONITORIAS'} agenda={true} />} />

                                        {/* Rota Sala VIP OAB */}
                                        <Route path={routes.salaVipOab} component={() => <CursosPorTipoScreen titulo={'Salas VIP'} tipo={'OAB_SALAS_VIP'} agenda={true} />} />

                                        {/* Rota Vade Mécum Digital */}
                                        <Route path={routes.vmDigitalOab} component={() => <CursosPorTipoScreen titulo={'Vade-Mécum Digital'} tipo={'OAB_VM_DIGITAL'} agenda={false} />} />

                                        {/* Rota Trilhas OAB */}
                                        <Route path={routes.trilhasOab} component={() => <CursosPorTipoScreen titulo={'Trilha Estratégica'} tipo={'OAB_TRILHA_ESTRATEGICA'} agenda={false} />} />

                                        {/* Rota Blog ECJ */}
                                        <Route path={routes.blogEcj} component={Screens.BlogEcjScreen} />

                                        {/* Rota Pacote */}
                                        <Route path={routes.pacote} component={Screens.PacoteScreen} />

                                        {/* Rota Últimas Aulas */}
                                        <Route path={routes.ultimasAulas} component={Screens.EstrategiaUltimaAulasScreen} />

                                        {/* Rota inicial ao logar */}
                                        <Route exact path='/dashboard' component={() => (
                                            <UserDetails>
                                                {details => {

                                                    let initialRoute = routes.cursos

                                                    if (details.blackfriday !== false && details.blackfriday !== null && details.blackfriday.controller === 'RenovarPromocaoJaneiro') {
                                                        initialRoute = routes.promocaoJaneiro2026
                                                    }

                                                    if (details.blackfriday !== false && details.blackfriday !== null && details.blackfriday.controller === 'RenovarPromocaoFevereiro') {
                                                        initialRoute = routes.renovacao
                                                    }

                                                    return <Redirect to={initialRoute} />
                                                }}
                                            </UserDetails>
                                        )} />

                                        {/* Rota Padrão */}
                                        <Route>
                                            {() => <Redirect to={routes.cursos} />}
                                        </Route>

                                    </Switch>
                                </Content>
                            </div>
                        )}
                    </UserDetails>
                </div>
            )
        }

    }

    static propTypes = {
        isAuthenticated: PropTypes.bool.isRequired,
        isProcessing: PropTypes.bool.isRequired,
        requestLogin: PropTypes.func.isRequired
    }

}

const mapStateToProps = state => ({
    isAuthenticated: isAuthenticated(state),
    isProcessing: isProcessing(state)
})

const mapDispatchToProps = dispatch => ({
    requestLogin(pathname) {
        dispatch(login(pathname))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)

const Content = styled.div`
    padding-top: 68px!important;
    ${mediaQuery.greaterThan('1250px')`padding-left: 300px;`}
`
